import React from "react";

import ConfirmDialog from "../../../shared/confirm-dialog";
import { useTrainingMigrationContext } from "./context/training-migration-provider";
import { StartCoursewareMigrationForm } from "./start-courseware-migration-form";

interface StartCoursewareMigrationDialogProps {
  regionCode: string;
}

export const StartCoursewareMigrationDialog: React.FC<
  StartCoursewareMigrationDialogProps
> = ({ regionCode }) => {
  const {
    coursewareMigrationDialogOpen,
    setCoursewareMigrationDialogOpen,
    resetCoursewareMigrationFormState,
    handleStartCoursewareMigration,
  } = useTrainingMigrationContext();

  return (
    <ConfirmDialog
      title="Start Courseware Migration"
      open={coursewareMigrationDialogOpen}
      setOpen={setCoursewareMigrationDialogOpen}
      onConfirm={async () => {
        handleStartCoursewareMigration();
      }}
      width="md"
      cancelBtnLabel="Cancel"
      confirmBtnLabel="Start"
      onCancel={() => {
        resetCoursewareMigrationFormState();
        setCoursewareMigrationDialogOpen(false);
      }}
    >
      <StartCoursewareMigrationForm regionCode={regionCode} />
    </ConfirmDialog>
  );
};
